import React from "react";
import { Search, RotateCcw } from "lucide-react";
import { AmbassadorFilters as FiltersType } from "../hooks/useAmbassadors";

const LEVELS = ["", "Starter", "Builder", "Pro"];

interface AmbassadorFiltersProps {
  filters: FiltersType;
  onFilterChange: (key: keyof FiltersType, value: string) => void;
  onApply: () => void;
  onReset: () => void;
  loading?: boolean;
}

export const AmbassadorFilters: React.FC<AmbassadorFiltersProps> = ({
  filters,
  onFilterChange,
  onApply,
  onReset,
  loading,
}) => {
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") onApply();
  };

  return (
    <div className="p-4 bg-white rounded-xl border space-y-3">
      <h3 className="text-sm font-semibold text-gray-700">Filtres</h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-3">
        <input
          type="text"
          placeholder="Nom"
          value={filters.name}
          onChange={(e) => onFilterChange("name", e.target.value)}
          onKeyDown={handleKeyDown}
          className="px-3 py-2 text-sm border rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500"
        />
        <input
          type="text"
          placeholder="Email"
          value={filters.email}
          onChange={(e) => onFilterChange("email", e.target.value)}
          onKeyDown={handleKeyDown}
          className="px-3 py-2 text-sm border rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500"
        />
        <select
          value={filters.level}
          onChange={(e) => onFilterChange("level", e.target.value)}
          className="px-3 py-2 text-sm border rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500"
        >
          <option value="">Tous les niveaux</option>
          {LEVELS.filter(Boolean).map((lvl) => (
            <option key={lvl} value={lvl}>
              {lvl}
            </option>
          ))}
        </select>
        <input
          type="text"
          placeholder="Code promo"
          value={filters.promo_code}
          onChange={(e) => onFilterChange("promo_code", e.target.value)}
          onKeyDown={handleKeyDown}
          className="px-3 py-2 text-sm border rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500"
        />
        <input
          type="text"
          placeholder="Téléphone"
          value={filters.phone}
          onChange={(e) => onFilterChange("phone", e.target.value)}
          onKeyDown={handleKeyDown}
          className="px-3 py-2 text-sm border rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500"
        />
        <input
          type="text"
          placeholder="Statut"
          value={filters.status}
          onChange={(e) => onFilterChange("status", e.target.value)}
          onKeyDown={handleKeyDown}
          className="px-3 py-2 text-sm border rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500"
        />
      </div>
      <div className="flex gap-2">
        <button
          onClick={onApply}
          disabled={loading}
          className="flex items-center gap-2 px-4 py-2 text-sm text-white bg-green-600 rounded-lg hover:bg-green-700 disabled:opacity-50"
        >
          <Search size={14} /> Rechercher
        </button>
        <button
          onClick={onReset}
          disabled={loading}
          className="flex items-center gap-2 px-4 py-2 text-sm text-gray-600 bg-gray-100 rounded-lg border hover:bg-gray-200 disabled:opacity-50"
        >
          <RotateCcw size={14} /> Réinitialiser
        </button>
      </div>
    </div>
  );
};

export default AmbassadorFilters;
